/* eslint-disable no-unused-vars */
/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
// import Cookies from 'js-cookie';
import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

// Store functionality
import modules from './modules';

// const vuexCookie = new VuexPersistence({
//   restoreState: (key, storage) => Cookies.get(key),
//   saveState: (key, state, storage) => Cookies.set(key, state, '7d'),
//   modules: [],
// });
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ['app', 'budgetDocuments', 'movies', 'categoryCodes', 'taxRates', 'mfcCodes'],
});
Vue.use(Vuex);

// Create a new store
const store = new Vuex.Store({
  modules,
  plugins: [
    // vuexCookie.plugin,
    vuexLocal.plugin,
  ],
});

export default store;
